import React from 'react';
import PropTypes from 'prop-types';

import TradeInCalculatorWidgetLayout from 'components/TradeInCalcWidgetLayout';
import OfficesMapWidgetLayout from 'components/OfficesMapWidgetLayout';
import SubscribeFormWidgetLayout from 'components/SubscribeFormWidgetLayout';
import VoteFormWidgetLayout from 'components/VoteFormWidgetLayout';

import {
  CALCULATOR_WIDGET,
  OFFICES_MAP_WIDGET,
  SUBSCRIBE_FORM_WIDGET,
  VOTE_FORM_WIDGET,
} from './constants';

export default function WidgetSwitcher({ customSlug, widgetData, widgetsProps, isMobile }) {
  switch (customSlug) {
    case CALCULATOR_WIDGET:
      return <TradeInCalculatorWidgetLayout {...{ ...widgetData, ...widgetsProps, isMobile }} />;
    case OFFICES_MAP_WIDGET:
      return <OfficesMapWidgetLayout {...{ ...widgetData, ...widgetsProps, isMobile }} />;
    case SUBSCRIBE_FORM_WIDGET:
      return <SubscribeFormWidgetLayout {...{ ...widgetData, ...widgetsProps, isMobile }} />;
    case VOTE_FORM_WIDGET:
      return <VoteFormWidgetLayout {...{ ...widgetData, ...widgetsProps, isMobile }} />;
    default:
      return null;
  }
}

WidgetSwitcher.propTypes = {
  customSlug: PropTypes.string,
  isMobile: PropTypes.bool,
  /* this prop is for tunneling actions and other widget-specific props */
  widgetsProps: PropTypes.object,
  /**
   * There is a lot of possible props, cause of multiple widgets,
   * so propTypes should be watched in widget layout.
   */
  widgetData: PropTypes.object,
};
